import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { SxProps } from '@mui/system';
import type { CSSProperties } from 'react';

import { styleConfigs } from '../../../../components/resources/styleConfigs';
import StackWrapper from '../../../../components/wrappers/StackWrapper';
import { COLORS } from '../../../../theme/colors';

// Design line-height is 130% across the screen.
const LINE_HEIGHT = 1.3;

// Full-screen takeover. Sits above app chrome (MUI modal z-index) so it covers
// both the learner and advisor layouts while a timeout is unresolved.
export const OverlayStyled = styled(StackWrapper)(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: styleConfigs.dimensions.width100vw,
  height: styleConfigs.dimensions.height100vh,
  alignItems: 'center',
  justifyContent: 'center',
  background: COLORS.alabaster,
  zIndex: 1300,
  gap: '1.75rem',
  padding: '1.5rem',
  textAlign: 'center',
}));

// Sizes use clamp() so the screen scales down on phones without a breakpoint
// jump; the upper bound of each clamp is the desktop value from the design.
export const getIconStyle = (): CSSProperties => ({
  width: 'clamp(5.5rem, 22vw, 8rem)',
  height: 'auto',
  marginBottom: '1.25rem',
});

export const getTitleSx = (theme: Theme): SxProps => ({
  fontSize: 'clamp(2rem, 6vw, 3.25rem)',
  lineHeight: LINE_HEIGHT,
  color: theme.palette.text.primary,
  textAlign: 'center',
});

export const getSubtitleSx = (theme: Theme): SxProps => ({
  fontSize: 'clamp(1.125rem, 2.5vw, 1.5rem)',
  lineHeight: LINE_HEIGHT,
  color: theme.palette.text.secondary,
  maxWidth: '37rem',
  textAlign: 'center',
});

export const getRetryButtonSx = (): SxProps => ({
  fontSize: '0.9375rem',
  lineHeight: LINE_HEIGHT,
  minWidth: '11.5rem',
  padding: '0.75rem 1.5rem',
  marginTop: '3.25rem',
});
